import * as querystring from 'querystring';

import { SearchHistory, SEARCH_TYPE } from '@bucketplace/design-system';

export const filterHistory = (history: SearchHistory, query: string): boolean =>
  typeof history === 'string' ? history !== query : history.query !== query;

export const getHistories = (): SearchHistory[] => {
  const matches = document.cookie.match(
    new RegExp('(?:^|; )searchHistory=([^;]*)')
  );
  return matches ? JSON.parse(decodeURIComponent(matches[1])) : [];
};

export const setHistories = (histories: SearchHistory[]): void => {
  const value = encodeURIComponent(JSON.stringify(histories.slice(0, 5)));
  document.cookie = `searchHistory=${value}; domain=${window.location.hostname}; max-age=2147483647;`;
};

export const appendHistory = (history: SearchHistory): void => {
  const query = typeof history === 'string' ? history : history.query;
  setHistories([
    history,
    ...getHistories().filter((h) => filterHistory(h, query)),
  ]);
};

export const removeHistory = (history: SearchHistory): void => {
  const query = typeof history === 'string' ? history : history.query;
  setHistories(getHistories().filter((h) => filterHistory(h, query)));
};

export const removeHistoryAll = (): void => {
  setHistories([]);
};

export function getSearchPath (
  type: typeof SEARCH_TYPE[keyof typeof SEARCH_TYPE],
  query: string
): string {
  switch (type) {
    case SEARCH_TYPE.STORE:
      return '/productions/feed?' + querystring.stringify({ query });
    case SEARCH_TYPE.EXPERT:
      return '/expert_users?' + querystring.stringify({ query });
    case SEARCH_TYPE.TOTAL:
      return '/search/index?' + querystring.stringify({ query });
    default:
      return '';
  }
}
